export default "__VITE_ASSET__BP2pD1Wy__"